import React from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'

const SLogo = styled.svg`
    width: auto;
    height: 35px;
`

export type FortumLandingPageLogoProps = {
    className?: ClassName
    style?: React.CSSProperties
    color?: string
}

export function FortumLandingPageLogo({
    className,
    style,
    color = '#ffffff',
}: FortumLandingPageLogoProps): React.ReactElement {
    return (
        <SLogo
            width="200"
            height="48"
            viewBox="0 0 200 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cn(className)}
            style={style}
        >
            <g clip-path="url(#clip0_4300_11856)">
                <path
                    d="M12.9631 28.9086C16.6203 35.2456 25.2879 37.9719 32.2233 33.9689C39.2153 29.9293 41.1303 21.0955 37.4698 14.7618C33.8126 8.42488 25.2048 5.66534 18.2129 9.70158C11.2808 13.7046 9.30588 22.575 12.9664 28.9086H12.9631Z"
                    fill={color}
                />
                <path
                    d="M11.2678 29.8895C7.09195 22.6581 9.33615 12.5709 17.2357 8.00931L18.9347 1.70227L12.6143 0C0.552173 6.96202 -3.58049 22.3822 3.38153 34.441C10.3435 46.4999 25.7737 50.6226 37.8359 43.6605L33.2012 35.6579C25.3016 40.2194 15.4437 37.1174 11.2678 29.8861V29.8895Z"
                    fill={color}
                />
                <path
                    d="M60.1553 8.46148C57.6684 8.46148 56.0991 10.1937 56.0991 12.9499V17.3851H61.7678V23.5625H56.0991V44.4751H48.3392V23.5625H44.7451V17.3851H48.3392V13.6547C48.3392 7.91954 49.4929 1.64575 58.5328 1.64575C60.6972 1.64575 61.7246 1.86186 63.8358 2.29408V8.94689C62.8616 8.73078 61.9972 8.46148 60.1553 8.46148ZM200.004 44.4651V28.769C200.004 24.2607 199.662 22.0896 198.691 20.4339C197.321 18.0367 194.428 16.5539 191.117 16.5539C187.064 16.5539 184.268 18.5521 182.383 22.8909C181.412 18.6684 179.015 16.5539 175.019 16.5539C171.022 16.5539 168.436 18.4956 166.381 22.718V17.1224H158.884V44.4651H166.667V31.7546C166.667 29.9859 166.78 28.6726 167.066 27.7018C167.751 25.2481 169.483 23.6489 171.594 23.6489C173.193 23.6489 174.35 24.4469 174.922 25.8765C175.321 26.9038 175.494 28.2736 175.494 30.7871V44.4651H183.334V31.2991C183.334 26.332 185.006 23.6489 188.261 23.6489C190.146 23.6489 191.42 24.4834 191.875 26.312C192.048 27.11 192.161 28.6161 192.161 30.3848V44.4651H200.001H200.004ZM155.891 31.1662V17.1224H148.108V31.1662C148.108 36.6453 147.064 38.4739 143.58 38.4739C140.095 38.4739 138.766 36.6487 138.766 31.625V17.1224H130.982V31.5053C130.982 37.4998 131.933 40.123 134.673 42.4071C136.841 44.1759 139.923 45.0902 143.52 45.0902C147.746 45.0902 151.17 43.7204 153.338 41.2069C155.107 39.1522 155.888 36.3528 155.888 31.1595M128.409 44.4585V38.331C127.156 38.6169 126.354 38.6734 125.214 38.6734C121.733 38.6734 120.629 37.3602 120.629 33.4802V23.5392H128.067V17.3252H120.629V8.38833L112.846 12.7836V34.8732C112.846 41.8951 116.081 44.9771 123.272 44.9771C125.101 44.9771 126.471 44.8641 128.409 44.4618M110.329 24.6164C108.959 23.988 108.101 23.8185 106.732 23.8185C102.396 23.8185 99.9026 27.0734 99.9026 32.3232V44.4618H92.1194V17.1224H99.6167V23.3464C100.588 19.1805 103.533 16.7235 107.872 16.7235C108.613 16.7235 109.355 16.8365 110.326 17.0094V24.6231L110.329 24.6164Z"
                    fill={color}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M89.3762 30.7606C89.3762 22.3689 84.4655 16.3711 75.9575 16.3711C67.4495 16.3711 62.4258 22.5385 62.4258 30.6442C62.4258 39.5512 67.7354 45.2033 76.1304 45.2033C83.897 45.2033 89.3762 39.2088 89.3762 30.7573V30.7606ZM81.5331 30.7041C81.5331 35.5549 79.4983 38.5604 76.0705 38.5604C72.6427 38.5604 70.2689 35.3853 70.2689 30.6442C70.2689 25.9031 72.4732 22.9009 75.9575 22.9009C79.4418 22.9009 81.5331 25.8499 81.5331 30.7041Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_4300_11856">
                    <rect width="200" height="47.0451" fill="white" />
                </clipPath>
            </defs>
        </SLogo>
    )
}
